import {Box, merge} from '@primer/react'
import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'
import type {ReactElement, ReactNode} from 'react'
import {testIdProps} from '@github-ui/test-id-props'
import type {Metadata} from './Metadata'

const defaultStyles: BetterSystemStyleObject = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  pr: 3,
  gap: 2,
  gridArea: 'metadata',
  flexGrow: 2,
}

export type MetadataContainerProps = {
  sx?: BetterSystemStyleObject
  children: ReactNode | Array<ReactElement<typeof Metadata>>
}

export function MetadataContainer({sx: externalSx, children}: MetadataContainerProps) {
  const sx = externalSx ? merge<BetterSystemStyleObject>(defaultStyles, externalSx) : defaultStyles
  return (
    <Box sx={sx} {...testIdProps('listview-item-metadata')}>
      {children}
    </Box>
  )
}

try{ MetadataContainer.displayName ||= 'MetadataContainer' } catch {}